export const DELEGATE_DMG_PATH =
  '/downloads/thisandthat-delegate-aarch64.dmg?v=20260914';
